<style scoped>
.spacer {
  margin-top: 25px;
  margin-bottom: 25px;
}
.help-block {
  margin-top: 5px;
  margin-bottom: 10px;
}
</style>
<template>
  <div>
    <form class="form">
      <div class="row">
        <div class="col-md-6">
          <div class="portlet light">
            <div class="portlet-title">
              <div class="caption">
                <span class="caption-subject bold uppercase">Product Team</span>
              </div>
            </div>
            <div class="portlet-body">
              <div class="row">
                <div class="col-md-6">
                  <span class="help-block">Type of Request</span>
                </div>
                <div class="col-md-6">
                  <span class="help-block">Team</span>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <select class="form-control" v-model="requestForm.type">
                    <option value>Select One</option>
                    <option value="Internal Request">Internal Request</option>
                    <option value="Enhancement Request">Enhancement Request</option>
                  </select>
                </div>
                <div class="col-md-6">
                  <select class="form-control" v-model="requestForm.team">
                    <option value>Select One</option>
                    <option
                      v-for="(project, index) in this.jira.projects"
                      :value="index"
                      v-bind:key="index"
                    >{{project.name}}</option>
                  </select>
                </div>
              </div>
              <br>
              <p>
                <b>Enhancement Requests:</b> This is a "must have, should have, could have, or won't have" idea.
              </p>
              <p>
                <b>Internal Requests:</b> This is not a request for an enhancement to the product,
                but rather a specific client request that is needed more immediately such as a demo request,
                specific reporting request, etc.
              </p>
            </div>
          </div>
          <div class="portlet light">
            <div class="portlet-title">
              <div class="caption">
                <span class="caption-subject bold uppercase">Short Description</span>
              </div>
            </div>
            <div class="portlet-body">
              <span class="help-block">Keep the description to 100 characters or less</span>
              <input type="text" class="form-control" v-model="requestForm.details.description">
            </div>
          </div>
          <div class="portlet light">
            <div class="portlet-title">
              <div class="caption">
                <span class="caption-subject bold uppercase">Enhancement Details</span>
              </div>
            </div>
            <div class="portlet-body">
              <span class="help-block">
                Explain in detail
                <b>what</b> is needed
              </span>
              <textarea class="form-control" rows="10" v-model="requestForm.details.what"></textarea>

              <div class="spacer"></div>

              <span class="help-block">
                Explain in detail
                <b>why</b> it is needed
              </span>
              <textarea class="form-control" rows="10" v-model="requestForm.details.why"></textarea>

              <div class="spacer"></div>

              <span class="help-block">
                Specify
                <b>when</b> it is needed by
              </span>
              <textarea class="form-control" rows="5" v-model="requestForm.details.when"></textarea>
            </div>
          </div>
        </div>

        <div class="col-md-6">
          <div class="portlet light">
            <div class="portlet-title">
              <div class="caption">
                <span class="caption-subject bold uppercase">Competitive Positioning</span>
              </div>
            </div>
            <div class="portlet-body">
              <div class="radio">
                <label>
                  <input type="radio" v-model="requestForm.scores.competitivePositioning" value="1">
                  <b>Low:</b> Provides little differentiation; Not required by users for competitive parity.
                </label>
              </div>
              <div class="radio">
                <label>
                  <input type="radio" v-model="requestForm.scores.competitivePositioning" value="3">
                  <b>Moderate:</b> Moderate competitive differentiator or becoming a required feature due to competitors.
                </label>
              </div>
              <div class="radio disabled">
                <label>
                  <input type="radio" v-model="requestForm.scores.competitivePositioning" value="5">
                  <b>High:</b> Major competitive differentiator or losing business without this feature.
                </label>
              </div>
            </div>
          </div>

          <div class="portlet light">
            <div class="portlet-title">
              <div class="caption">
                <span class="caption-subject bold uppercase">Customer Benefit</span>
              </div>
            </div>
            <div class="portlet-body">
              <div class="radio">
                <label>
                  <input
                    type="radio"
                    v-model="requestForm.scores.customerBenefit"
                    value="1"
                    checked
                  >
                  <b>Low:</b> Minor annoyance or small benefit; happens rarely; not urgent.
                </label>
              </div>
              <div class="radio">
                <label>
                  <input type="radio" v-model="requestForm.scores.customerBenefit" value="3">
                  <b>Moderate:</b> Solves some moderate pain or provides some interesting benefit; occurs often enough to notice; wants a solution sooner than later.
                </label>
              </div>
              <div class="radio disabled">
                <label>
                  <input type="radio" v-model="requestForm.scores.customerBenefit" value="5">
                  <b>High:</b> Solves a major customer pain or provides a significant benefit; Occurs often; needs a solution as soon as possible.
                </label>
              </div>
            </div>
          </div>

          <div class="portlet light">
            <div class="portlet-title">
              <div class="caption">
                <span class="caption-subject bold uppercase">Opportunity Size</span>
              </div>
            </div>
            <div class="portlet-body">
              <div class="radio">
                <label>
                  <input
                    type="radio"
                    v-model="requestForm.scores.opportunitySize"
                    value="1"
                    checked
                  >
                  <b>Low:</b> Less than 10% of users potentially impacted; No major users.
                </label>
              </div>
              <div class="radio">
                <label>
                  <input type="radio" v-model="requestForm.scores.opportunitySize" value="3">
                  <b>Moderate:</b> About 25% of users impacted; At least one major user impacted.
                </label>
              </div>
              <div class="radio disabled">
                <label>
                  <input type="radio" v-model="requestForm.scores.opportunitySize" value="5">
                  <b>High:</b> 50%+ users impacted or can benefit; Multiple major users impacted.
                </label>
              </div>
            </div>
          </div>
          <div class="portlet light">
            <div class="portlet-title">
              <div class="caption">
                <span class="caption-subject bold uppercase">Strategic Alignment</span>
              </div>
            </div>
            <div class="portlet-body">
              <div class="radio">
                <label>
                  <input
                    type="radio"
                    v-model="requestForm.scores.strategicAlignment"
                    value="1"
                    checked
                  >
                  <b>Low:</b> Weak alignment to strategic objectives; some importance to business; modest impact
                </label>
              </div>
              <div class="radio">
                <label>
                  <input type="radio" v-model="requestForm.scores.strategicAlignment" value="3">
                  <b>Moderate:</b> Mostly aligned to strategic; important to business; good impact.
                </label>
              </div>
              <div class="radio disabled">
                <label>
                  <input type="radio" v-model="requestForm.scores.strategicAlignment" value="5">
                  <b>High:</b> Strong alignment to strategic objectives; very important to business; high impact.
                </label>
              </div>
            </div>
          </div>
          <div class="portlet light">
            <div class="portlet-title">
              <div class="caption">
                <span class="caption-subject bold uppercase">Business Risk</span>
              </div>
            </div>
            <div class="portlet-body">
              <div class="radio">
                <label>
                  <input type="radio" v-model="requestForm.scores.businessRisk" value="1" checked>
                  <b>Low:</b> Little affect to revenue gains or retention issues; Little cross-functional team impact.
                </label>
              </div>
              <div class="radio">
                <label>
                  <input type="radio" v-model="requestForm.scores.businessRisk" value="3">
                  <b>Moderate:</b> Negatively affects sales volume or retention numbers if not addressed; Medium cross-functional team impacted.
                </label>
              </div>
              <div class="radio disabled">
                <label>
                  <input type="radio" v-model="requestForm.scores.businessRisk" value="5">
                  <b>High:</b> Affects a large number of clients; Large scale reputation damage may occur; Large cross-functional team disruption and impact.
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-8"></div>
        <div class="col-md-3" style="color: #ff0000">
          <div v-if="errors.length > 0">
            <b>Please correct the following error(s):</b>
            <ul>
              <li v-for="(error, index) in errors" v-bind:key="index">{{ error }}</li>
            </ul>
          </div>
        </div>
        <div class="col-md-1">
          <button
            class="btn btn-large dark pull-right"
            type="button"
            v-on:click="checkForm()"
            :disabled="buttonDisabled"
          >{{buttonText}}</button>
        </div>
      </div>

      <div class="spacer"></div>
    </form>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "EnhancementNew",
  props: ["profile", "jira"],
  data() {
    return {
      errors: [],
      buttonText: "Send Request",
      buttonDisabled: false,
      requestForm: {
        team: "",
        type: "",
        details: {
          description: "",
          what: "",
          why: "",
          when: ""
        },
        scores: {
          competitivePositioning: 1,
          customerBenefit: 1,
          opportunitySize: 1,
          strategicAlignment: 1,
          businessRisk: 1
        },
        profile: {
          name: this.profile.name,
          email: this.profile.email
        }
      }
    };
  },
  methods: {
    checkForm: function(e) {
      this.errors = [];

      if (!this.requestForm.type) {
        this.errors.push("Request Type is required.");
      }
      if (!this.requestForm.team) {
        this.errors.push("Team is required.");
      }

      if (this.errors.length == 0) {
        this.submitRequest();
      }

      e.preventDefault();
    },
    submitRequest() {
      this.buttonText = "Processing ...";
      this.buttonDisabled = true;

      axios
        // .post("http://localhost:3001/tickets/create", this.requestForm)
        .post(
          "https://fwtyoowisa.execute-api.us-east-1.amazonaws.com/dev/tickets/create",
          this.requestForm
        )
        .then(response => {
          this.logRequest(response);

          setTimeout(
            () => this.$router.push({ path: "/enhancement/status" }),
            2000
          );
        });
    },
    logRequest() {}
  }
};
</script>
